import React, { Component } from 'react';
import { connect } from 'react-redux';
import withModal from '../../../../lib/hoc/withModal';
import { couponActions } from '../../../../store/modules/coupon';
import ExcelUploadCouponProductValidFailModal from '../../../../views/coupon/common/modal/ExcelUploadCouponProductValidFailModal';
import { setApplyCouponDiscount } from '../../../../lib/utils/couponUtils';
import { downloadInvalidItemsExcel } from '../../../../lib/utils/couponInvalidItemsExcelUtils';
import { useCouponFormStore, syncProductItemsToZustand } from '../../../../store/couponFormStore';

export class ExcelUploadCouponProductValidFailModalContainer extends Component {
  /**
   *  모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({
      name: 'excelUploadCouponProductValidFailModal',
      value: false,
    });
  };

  /**
   * 가능 항목만 업로드
   */
  onSubmit = () => {
    const { data, setCouponProductItemListExcelUpload } = this.props;
    const zustandState = useCouponFormStore.getState();
    // coupon-v2에서는 Zustand 값 사용, 레거시에서는 Redux 폴백
    const discountType = zustandState._active
      ? zustandState.couponInfo.discountType
      : this.props.discountType;
    const discountAmount = zustandState._active
      ? zustandState.couponInfo.discountAmount
      : this.props.discountAmount;
    const validProductList = data.productList.filter((item) => !item.productIsInvalid);

    const hasValidProductList = validProductList.length > 0;

    if (hasValidProductList) {
      const processedProductList = setApplyCouponDiscount(validProductList, discountType, discountAmount);
      setCouponProductItemListExcelUpload({ productList: processedProductList });

      syncProductItemsToZustand(processedProductList);
    }

    this.closeModal();
  };

  /**
   * 불가능 항목 다운로드
   */
  handleDownloadInvalidItems = () => {
    const { data } = this.props;
    const invalidProductList = data.productList.filter((item) => item.productIsInvalid);

    if (invalidProductList.length > 0) {
      downloadInvalidItemsExcel(invalidProductList, 'product');
    }
  };

  render() {
    const { isOpen, data } = this.props;

    return (
      <ExcelUploadCouponProductValidFailModal
        isOpen={isOpen}
        data={data}
        closeModal={this.closeModal}
        onSubmit={this.onSubmit}
        handleDownloadInvalidItems={this.handleDownloadInvalidItems}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.coupon.excelUploadCouponProductValidFailModal.isOpen,
    data: state.coupon.excelUploadCouponProductValidFailModal.data,
    discountType: state.coupon.couponCreate.couponInfo.discountType,
    discountAmount: state.coupon.couponCreate.couponInfo.discountAmount,
  };
};

const mapDispatchToProps = {
  toggleModal: couponActions.toggleModal,
  setCouponProductItemListExcelUpload: couponActions.setCouponProductItemListExcelUpload,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(ExcelUploadCouponProductValidFailModalContainer));
